import { MailingId } from 'modules/mailing/types/mailing-interface'
import { useEffect, useState } from 'react'
import Frame, { FrameContextConsumer } from 'react-frame-component'
import useMediaQuery from 'shared/hooks/use-media-query'
import { getEmailEditorUrl } from 'shared/utils/get-email-editor-url'
import { twJoin } from 'tailwind-merge'
import { ExtendedState } from '../../types/common'

export type NewEditorProps = {
  tempState: ExtendedState
  isPreFetching?: boolean
  mailingId: MailingId
  disabled?: boolean
}

export const NewEditor = ({ tempState, isPreFetching, mailingId, disabled }: NewEditorProps) => {
  const [height, setHeight] = useState(0)
  const { isLG } = useMediaQuery()

  return (
    <Frame
      style={{ height: isLG ? height : 'inherit' }}
      className={twJoin(`w-full`, (isPreFetching || disabled) && 'pointer-events-none')}
      tabIndex={disabled ? -1 : undefined}
    >
      <FrameContextConsumer>
        {({ document }) => (
          <FrameContent
            document={document}
            setHeight={setHeight}
            tempState={tempState}
            mailingId={mailingId}
          />
        )}
      </FrameContextConsumer>
    </Frame>
  )
}

interface FrameContentProps extends Pick<NewEditorProps, 'tempState' | 'mailingId'> {
  document?: Document
  setHeight: (height: number) => void
}

const FrameContent = ({ tempState, mailingId, setHeight, document }: FrameContentProps) => {
  useEffect(() => {
    const height = document?.body.clientHeight
    if (!height) return
    setHeight(height)
  }, [document, setHeight])

  return (
    <>
      <a
        style={{ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0 }}
        target={'_parent'}
        href={getEmailEditorUrl(mailingId)}
      />
      <div dangerouslySetInnerHTML={{ __html: tempState.html ?? '' }} />
    </>
  )
}
